// extracted by mini-css-extract-plugin
export default {"joiningHearts":"joiningHearts__MTJlM","loader":"loader__N2IxN","petal":"petal__MTg5O","spin":"spin__OGNjO"};